import {Component} from '@angular/core';

import {PageHeaderComponent} from "@numizmat/components";

@Component({
  selector: 'nz-privacy-policy-page',
  imports: [
    PageHeaderComponent
  ],
  templateUrl: './privacy-policy-page.component.html',
  styleUrl: './privacy-policy-page.component.scss'
})
export class PrivacyPolicyPageComponent {
}
